/**
 * Centralized query keys for TanStack Query
 * Using a factory pattern for consistent key generation
 */

export const queryKeys = {
  all: ['hobbes'] as const,

  apiKeys: {
    all: () => [...queryKeys.all, 'apiKeys'] as const,
    list: (organizationId: string) =>
      [...queryKeys.apiKeys.all(), organizationId, 'list'] as const,
  },

  webhooks: {
    all: () => [...queryKeys.all, 'webhooks'] as const,
    list: (organizationId: string) =>
      [...queryKeys.webhooks.all(), organizationId, 'list'] as const,
    deliveries: (organizationId: string, filters?: Record<string, unknown>) =>
      [...queryKeys.webhooks.all(), organizationId, 'deliveries', filters ?? {}] as const,
  },

  slack: {
    all: () => [...queryKeys.all, 'slack'] as const,
    config: (organizationId: string) =>
      [...queryKeys.slack.all(), organizationId, 'config'] as const,
    channels: (organizationId: string) =>
      [...queryKeys.slack.all(), organizationId, 'channels'] as const,
  },

  evaluator: {
    all: () => [...queryKeys.all, 'evaluator'] as const,
    datasets: (orgId: string) => [...queryKeys.evaluator.all(), orgId, 'datasets'] as const,
    dataset: (name: string, orgId: string) => [...queryKeys.evaluator.all(), orgId, 'dataset', name] as const,
    datasetItem: (datasetName: string, itemId: string, orgId: string) =>
      [...queryKeys.evaluator.all(), orgId, 'dataset', datasetName, 'item', itemId] as const,
    simulationBatches: (orgId: string) => [...queryKeys.evaluator.all(), orgId, 'simulationBatches'] as const,
    simulationBatch: (orgId: string, batchId: string) =>
      [...queryKeys.evaluator.all(), orgId, 'simulationBatch', batchId] as const,
  },

  customEvals: {
    all: () => [...queryKeys.all, 'customEvals'] as const,
    sets: (orgId: string) => [...queryKeys.customEvals.all(), orgId, 'sets'] as const,
    set: (orgId: string, setId: string) =>
      [...queryKeys.customEvals.all(), orgId, 'set', setId] as const,
  },

  onboardingStatus: {
    all: () => [...queryKeys.all, 'onboardingStatus'] as const,
    byOrg: (organizationId: string) =>
      [...queryKeys.onboardingStatus.all(), organizationId] as const,
  },

  askHobbesHistory: {
    all: () => [...queryKeys.all, 'askHobbesHistory'] as const,
    list: (organizationId: string) =>
      [...queryKeys.askHobbesHistory.all(), organizationId, 'list'] as const,
    chat: (chatId: string) =>
      [...queryKeys.askHobbesHistory.all(), 'chat', chatId] as const,
  },
} as const;
